module.exports = __webpack_public_path__ + "img/map.e0546c5b.svg";